import { render, staticRenderFns } from "./practiceResult.vue?vue&type=template&id=0ba8e362&scoped=true"
import script from "./practiceResult.vue?vue&type=script&lang=js"
export * from "./practiceResult.vue?vue&type=script&lang=js"
import style0 from "./practiceResult.vue?vue&type=style&index=0&id=0ba8e362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba8e362",
  null
  
)

export default component.exports